import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  card: {
    width: '100%',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '0',
    borderRadius: '4px',
    overflow: 'initial',
    transition: 'color 0.2s ease-in-out',
    boxShadow: 'none',
    '&[data-error="true"]': {
      color: '#be1224',
      border: '1px solid #be1224'
    },
    '&[data-warn="true"]': {
      color: '#ffa000',
      border: '1px solid #ffa000'
    }
  },
  cardContent: {
    gap: '8px',
    padding: '4px 8px !important'
  },
  cardGrip: {
    gap: '8px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'grab'
  },
  icon: {
    fontSize: '16px'
  }
}));
